import { FC, useEffect } from 'react';
import { Popup } from '~/entities/Popup/Popup';

import { zodResolver } from '@hookform/resolvers/zod';
import { SubmitHandler, useForm } from 'react-hook-form';
import { z } from 'zod';
import { cvaAddParkingPageLabel } from '~/pages/AddParkingPage/ui/AddParkingPageStyles';
import {
  cvaAddPlacePageInput,
  cvaAddPlacePageErrorMessage,
} from '~/pages/AddPlacePage/ui/AddPlacePageStyle';
import { Input } from '~/shared/ui/Input/Input';
import { useUpdateUser } from '~/shared/hooks/useUpdateUser';
import { useUserStore } from '~/shared/store/userStore';

interface Props {
  onClose: () => void;
  open: boolean;
}

const schema = z.object({
  first_name: z
    .string()
    .min(3, { message: 'Минимальная длина имени 3 символа' }),
  second_name: z
    .string()
    .min(3, { message: 'Минимальная длина фамилии 3 символа' }),
});

export type FormData = z.infer<typeof schema>;

export const EditProfile: FC<Props> = ({ onClose, open }) => {
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<FormData>({
    resolver: zodResolver(schema),
    mode: 'onChange',
  });

  const { state } = useUserStore();

  useEffect(() => {
    state.first_name && setValue('first_name', state.first_name);
    state.second_name && setValue('second_name', state.second_name);
  }, [state]);

  const { update, isSuccess, isLoading, error } = useUpdateUser();

  const onSubmitEdit: SubmitHandler<FormData> = async (data) => {
    update(data);
  };

  useEffect(() => {
    if (isSuccess) {
      onClose();
    }
  }, [isSuccess]);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmitEdit)}>
        <Popup
          open={open}
          formPopup
          onClose={onClose}
          title={'Редактировать<br/> профиль'}
          button={{
            text: 'Сохранить',
            action: () => {
              // handleSubmit(onSubmit);
            },
            disabled: !isValid,
            isLoading: isLoading,
          }}
          fields={
            <>
              <div className="text-left mt-1.2">
                <label
                  htmlFor={'first_name'}
                  className={cvaAddParkingPageLabel()}>
                  Имя
                </label>
                <Input
                  name={'first_name'}
                  placeholder={'Не указано'}
                  register={register}
                  className={cvaAddPlacePageInput()}
                />

                {errors.first_name && (
                  <p className={cvaAddPlacePageErrorMessage()}>
                    {errors.first_name.message}
                  </p>
                )}
                {error && (
                  <p className={cvaAddPlacePageErrorMessage()}>
                    {error?.response?.data?.errors?.first_name?.[0]}
                  </p>
                )}
              </div>
              <div className="text-left mt-1.2">
                <label
                  htmlFor={'second_name'}
                  className={cvaAddParkingPageLabel()}>
                  Фамилия
                </label>
                <Input
                  className={cvaAddPlacePageInput()}
                  register={register}
                  name={'second_name'}
                  placeholder={'Не указано'}
                  // clearble={!!nameValue}
                  // clear={() => setValue('name', '')}
                />
                {errors.second_name && (
                  <p className={cvaAddPlacePageErrorMessage()}>
                    {errors.second_name.message}
                  </p>
                )}
                {error && (
                  <p className={cvaAddPlacePageErrorMessage()}>
                    {error?.response?.data?.errors?.second_name?.[0]}
                  </p>
                )}
              </div>
            </>
          }
        />
      </form>
    </>
  );
};
